


var permission = {}
permission.location = {}
permission.camera = {}




permission.camera.authorized = async function(){

    //Check if has permission
    return new Promise(function(resolve,reject) {
        if(device.platform == "browser") {
            


            if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
                // Firefox 38+ seems having support of enumerateDevicesx
                navigator.enumerateDevices = function(callback) {
                    navigator.mediaDevices.enumerateDevices().then(callback);
                };
            }
            
            var MediaDevices = [];
            var isHTTPs = location.protocol === 'https:';
            var canEnumerate = false;
            
            if (typeof MediaStreamTrack !== 'undefined' && 'getSources' in MediaStreamTrack) {
                canEnumerate = true;
            } else if (navigator.mediaDevices && !!navigator.mediaDevices.enumerateDevices) {
                canEnumerate = true;
            }
            
            var hasMicrophone = false;
            var hasSpeakers = false;
            var hasWebcam = false;
            
            var isMicrophoneAlreadyCaptured = false;
            var isWebcamAlreadyCaptured = false;
            
            function checkDeviceSupport(callback) {
                if (!canEnumerate) {
                    return;
                }
            
                if (!navigator.enumerateDevices && window.MediaStreamTrack && window.MediaStreamTrack.getSources) {
                    navigator.enumerateDevices = window.MediaStreamTrack.getSources.bind(window.MediaStreamTrack);
                }
            
                if (!navigator.enumerateDevices && navigator.enumerateDevices) {
                    navigator.enumerateDevices = navigator.enumerateDevices.bind(navigator);
                }
            
                if (!navigator.enumerateDevices) {
                    if (callback) {
                        callback();
                    }
                    return;
                }
            
                MediaDevices = [];
                navigator.enumerateDevices(function(devices) {
                    devices.forEach(function(_device) {
                        var device = {};
                        for (var d in _device) {
                            device[d] = _device[d];
                        }
            
                        if (device.kind === 'audio') {
                            device.kind = 'audioinput';
                        }
            
                        if (device.kind === 'video') {
                            device.kind = 'videoinput';
                        }
            
                        var skip;
                        MediaDevices.forEach(function(d) {
                            if (d.id === device.id && d.kind === device.kind) {
                                skip = true;
                            }
                        });
            
                        if (skip) {
                            return;
                        }
            
                        if (!device.deviceId) {
                            device.deviceId = device.id;
                        }
            
                        if (!device.id) {
                            device.id = device.deviceId;
                        }
            
                        if (!device.label) {
                            device.label = 'Please invoke getUserMedia once.';
                            if (!isHTTPs) {
                                device.label = 'HTTPs is required to get label of this ' + device.kind + ' device.';
                            }
                        } else {
                            if (device.kind === 'videoinput' && !isWebcamAlreadyCaptured) {
                                isWebcamAlreadyCaptured = true;
                            }
            
                            if (device.kind === 'audioinput' && !isMicrophoneAlreadyCaptured) {
                                isMicrophoneAlreadyCaptured = true;
                            }
                        }
            
                        if (device.kind === 'audioinput') {
                            hasMicrophone = true;
                        }
            
                        if (device.kind === 'audiooutput') {
                            hasSpeakers = true;
                        }
            
                        if (device.kind === 'videoinput') {
                            hasWebcam = true;
                        }
            
                        // there is no 'videoouput' in the spec.
            
                        MediaDevices.push(device);
                    });
            
                    if (callback) {
                        callback();
                    }
                });
            }
            
            // check for microphone/camera support!
            checkDeviceSupport(function() {
                /*document.write('hasWebCam: ', hasWebcam, '<br>');
                document.write('hasMicrophone: ', hasMicrophone, '<br>');
                document.write('isMicrophoneAlreadyCaptured: ', isMicrophoneAlreadyCaptured, '<br>');
                document.write('isWebcamAlreadyCaptured: ', isWebcamAlreadyCaptured, '<br>'); */
                if(isWebcamAlreadyCaptured) resolve(true)
                else reject(false)
                
            });








        }else {
            cordova.plugins.diagnostic.isCameraAuthorized({
                successCallback: function(authorized){
                    if(authorized) resolve(true)
                    else reject(false)
                },
                errorCallback: function(error){
                    reject(error)
                }
            });
        }
    })
}




permission.location.authorized = async function(){

    //Check if has permission
    return new Promise(function(resolve,reject) {
        if(device.platform == "browser") {
            if (navigator.geolocation) {
                
                navigator.geolocation.getCurrentPosition(function(loc){
                    console.log("Found Location")
                    resolve(true)
                },function(err) {
                    console.log(err)
                    reject(err)
                });
              } else {
                reject(false)
              }

        }else {
            cordova.plugins.diagnostic.isLocationAuthorized(function(authorized){
                if(authorized)resolve(true)
                else reject(false)
            }, function(error){
                reject(false)
            });
        }
    })
}


permission.location.enabled = async function(){

    //Check if has permission
    return new Promise(function(resolve,reject) {

        if(device.platform == "browser") {
            if (navigator.geolocation) {
                resolve(true)
              } else {
                reject(false)
              }

        }else {
            cordova.plugins.diagnostic.isLocationEnabled(function(authorized){
                if(authorized)resolve(true)
                else reject(false)
            }, function(error){
                reject(error)
            });
        }
    })
}



permission.camera.request = async function(){


    return new Promise(function(resolve,reject){

        if(device.platform == "browser") {
            navigator.getMedia = ( navigator.getUserMedia || // use the proper vendor prefix
                navigator.webkitGetUserMedia ||
                navigator.mozGetUserMedia ||
                navigator.msGetUserMedia);

                navigator.getMedia({video: true}, function() {
                // webcam is available
                console.log("camera available")
                }, function() {
                // webcam is not available
                console.log("camera  note available")
                
                });

        }else {

            cordova.plugins.diagnostic.requestCameraAuthorization({
                successCallback: function(status){
                    if(status == cordova.plugins.diagnostic.permissionStatus.GRANTED ){
                        resolve(true)
                    }else {
                        reject(false)
                    }
                },
                errorCallback: function(error){
                    console.error(error);
                    reject(false)
                }
            });
        }
    




    })


}

permission.location.request = async function(){


    return new Promise(function(resolve,reject){

        if(device.platform == "browser") {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function(){
                    this.resolve(true)
                }.bind({resolve,reject}),function(){
                    this.reject(false)
                }.bind({resolve,reject}))
                
              } else {
                reject(false)
              }

        } else {

            console.log("Location request")
            cordova.plugins.diagnostic.getLocationAuthorizationStatus(function(status){
                switch(status){
                    case cordova.plugins.diagnostic.permissionStatus.NOT_REQUESTED:
                        requestLocation(this.resolve,this.reject)
                        break;
                    case cordova.plugins.diagnostic.permissionStatus.GRANTED:
                        this.resolve(true)
                        break;
                    case cordova.plugins.diagnostic.permissionStatus.DENIED_ONCE:
                        switchToSettings(this.resolve,this.reject)
                        break;
                    case cordova.plugins.diagnostic.permissionStatus.DENIED_ALWAYS:
                        switchToSettings(this.resolve,this.reject)
                        break;
                }
            }.bind({resolve,reject}), function(error){
                this.reject(false)
            }.bind({resolve,reject}));


            function switchToSettings(resolve,reject){
                cordova.plugins.diagnostic.switchToSettings(function(){
                    resolve(true)
                }, function(error){
                    reject(false)
                });
            }

            function requestLocation(resolve,reject){
                cordova.plugins.diagnostic.requestLocationAuthorization(function(status){

                    console.log("Location request response" , status)
                    switch(status){
                        case cordova.plugins.diagnostic.permissionStatus.NOT_REQUESTED:
                            this.reject(false)
                            break;
                        case cordova.plugins.diagnostic.permissionStatus.DENIED_ALWAYS:
                            this.reject(false)
                            break;
                        case cordova.plugins.diagnostic.permissionStatus.GRANTED:
                            this.resolve(true)
                            break;
                        case cordova.plugins.diagnostic.permissionStatus.GRANTED_WHEN_IN_USE:
                            this.resolve(true)
                            break;
                    }
                }.bind({resolve,reject}), function(error){
                    console.log("Location request response" , error)
                    console.error(error);
                    this.reject(false)
                }.bind({reject,resolve}), cordova.plugins.diagnostic.locationAuthorizationMode.ALWAYS);
            }
        }
    
    })


}


export default permission